export default "__VITE_ASSET__DR3cYnXF__"